/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default; 

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Layouts
Vue.component('general-searchbox', require('./components/_layouts/searchbox.vue').default);
Vue.component('general-pagination', require('./components/_layouts/pagination.vue').default);
Vue.component('general-loading', require('./components/_layouts/loading.vue').default);
Vue.component('general-delete-modal', require('./components/_layouts/confirmDeleteModal.vue').default);
Vue.component('general-alert-modal', require('./components/_layouts/alertModal.vue').default);
Vue.component('form-error', require('./components/_layouts/formError.vue').default);


// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('cms', require('./components/CMS/Cms.vue').default);
Vue.component('cms-form', require('./components/CMS/form.vue').default);
Vue.component('cms-category', require('./components/CMS/category/category.vue').default);
Vue.component('cms-category-form', require('./components/CMS/category/form.vue').default);
Vue.component('cms-tag', require('./components/CMS/tag/tag.vue').default);
Vue.component('cms-tag-form', require('./components/CMS/tag/form.vue').default);

Vue.component('campaign', require('./components/Campaign/Campaign.vue').default);
Vue.component('campaign-form', require('./components/Campaign/form.vue').default);
// Vue.component('campaign-category', require('./components/Campaign/category/category.vue').default);
// Vue.component('campaign-category-form', require('./components/Campaign/category/form.vue').default);
// Vue.component('campaign-tag', require('./components/Campaign/tag/tag.vue').default);
// Vue.component('campaign-tag-form', require('./components/Campaign/tag/form.vue').default);

Vue.component('delivery-history', require('./components/deliveryHistory/index.vue').default);
Vue.component('delivery-history-form', require('./components/deliveryHistory/form.vue').default);

Vue.component('product-page', require('./components/Product_page/ProductPage.vue').default);
Vue.component('product-page-form', require('./components/Product_page/form.vue').default);

Vue.component('medias', require('./components/media/medias.vue').default);
Vue.component('media-form', require('./components/media/form.vue').default);

Vue.component('service', require('./components/service/service.vue').default);
Vue.component('service-form', require('./components/service/form.vue').default);

Vue.component('announcement', require('./components/announcement/announcement.vue').default);
Vue.component('announcement-form', require('./components/announcement/form.vue').default);

Vue.component('menus', require('./components/menus/menus.vue').default);
Vue.component('menu-form', require('./components/menus/form.vue').default);
Vue.component('menu-category', require('./components/menus/menuCategory.vue').default);
Vue.component('menu-category-form', require('./components/menus/categoryForm.vue').default);


Vue.component('product', require('./components/product/product.vue').default);
Vue.component('product-detail', require('./components/product/detail.vue').default);
Vue.component('product-edit', require('./components/product/edit.vue').default);

Vue.component('users-component', require('./components/user/user.vue').default);
Vue.component('user-form', require('./components/user/form.vue').default);

Vue.component('frontend-users-component', require('./components/frontend/user/user.vue').default);

Vue.component('roles-component', require('./components/role/role.vue').default);
Vue.component('role-form', require('./components/role/form.vue').default);

Vue.component('orders-component', require('./components/order/order.vue').default);
Vue.component('order-form', require('./components/order/form.vue').default);
Vue.component('delivery-criteria-form', require('./components/deliveryCriteria/form.vue').default);

Vue.component('service-location', require('./components/service_location/service_location.vue').default);
Vue.component('service-location-form', require('./components/service_location/form.vue').default);
Vue.component('product-filter', require('./components/product_filter/pruductFilter.vue').default);
Vue.component('priority-managent', require('./components/product_filter/PriorityManagent.vue').default);
Vue.component('control-product', require('./components/ControlProduct/ControlProduct.vue').default);
// Vue.component('open-hour-form', require('./components/openHour/form.vue').default);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
